// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d2701b02","156":"fbe8f69c","185":"cde62d07","194":"f2573dd9","200":"a9adc7d8","241":"e32a32d9","565":"ce731964","616":"53c650cf","654":"293b3567","734":"c4d76263","768":"f1dce226"}[chunkId] + ".chunk.js";
};